import memoize from 'lodash/memoize'

export const DEFAULT_STORAGE_PREFIX = '@@triodos-onboarding'

function getStorageService(storagePrefix = DEFAULT_STORAGE_PREFIX) {
  const getKey = key => `${storagePrefix}/${key}`

  return {
    setItem(key, value) {
      localStorage.setItem(getKey(key), value)
    },
    getItem(key) {
      return localStorage.getItem(getKey(key))
    },
    removeItem(key) {
      localStorage.removeItem(getKey(key))
    }
  }
}

export default memoize(getStorageService)
